(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/play/page.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/play/page.js');
"use strict";


const {
  createContext,
  useEffect
} = React;
const {
  useTicketInfo
} = svs.eInstant.shared.hooks;
const {
  matchPath,
  useHistory
} = ReactRouterDOM;
const PlayContext = createContext();
setGlobal('svs.eInstant.lobby.play.PlayContext', PlayContext);
const PlayProvider = _ref => {
  let {
    children,
    ticketInfo,
    isDemo,
    wager
  } = _ref;
  return React.createElement(PlayContext.Provider, {
    value: {
      wager,
      ticketInfo,
      isDemo
    }
  }, children);
};
const Play = _ref2 => {
  let {
    match
  } = _ref2;
  const {
    BET_DETAIL,
    DEMO_PLAY,
    PLAY
  } = svs.eInstant.constants.ROUTES;
  const {
    Background
  } = svs.eInstant.shared.components;
  const GameLauncherLEIA = svs.eInstant.lobby.play.leia.GameLauncher;
  const {
    gameId
  } = match.params;
  const history = useHistory();
  const betDetailRoute = matchPath(match.path, {
    path: BET_DETAIL,
    exact: true
  });
  const {
    LEIA
  } = svs.eInstant.lobby.play.utils.GAME_PROVIDERS;
  const isDemo = match.path.includes('provspela');
  const wager = svs.eInstant.data.wager && betDetailRoute ? svs.eInstant.data.wager : null;
  const {
    ticketInfo = null,
    loading
  } = useTicketInfo({
    wager,
    gameId
  });
  const {
    update
  } = svs.eInstant.shared.hooks.useMetaTags({
    ticketInfo
  });
  useEffect(() => {
    ticketInfo && update(isDemo ? DEMO_PLAY : PLAY);
  }, [ticketInfo]);
  if (!ticketInfo && !loading) {
    gameId && svs.eInstant.logger.warn("failed to start game with gameId: ".concat(gameId));
    svs.ticketgames.ticketUtility.utils.showGameClosedDialog({
      onClose: () => {
        history.push(svs.eInstant.constants.ROUTES.LOBBY);
      }
    });
    return null;
  }
  if (!ticketInfo && loading) {
    return React.createElement(Background, null);
  }
  const {
    gameProvider
  } = ticketInfo;
  return React.createElement(Background, null, React.createElement(PlayProvider, {
    isDemo: isDemo,
    ticketInfo: ticketInfo,
    wager: wager
  }, gameProvider === LEIA && React.createElement(GameLauncherLEIA, null)));
};
setGlobal('svs.eInstant.lobby.Play', Play);

 })(window);